import { render } from "./PurplePanel.vue?vue&type=template&id=717d80db"
import script from "./PurplePanel.vue?vue&type=script&lang=js"
export * from "./PurplePanel.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__